export default __webpack_public_path__ + "static/Vlad-Danciu-d02918aac6ee4acd553bc9e89dc05ebd.png";